import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/marketing/add-circle.svg'
import _imports_1 from '@/assets/marketing/edit.svg'
import _imports_2 from '@/assets/deleteIcon.svg'


const _withScopeId = n => (_pushScopeId("data-v-966c084e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-layout-content" }
const _hoisted_2 = {
  class: "left-layout bf",
  style: {"width":"50%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "标签管理", -1))
const _hoisted_4 = { style: {"display":"flex","align-items":"center","height":"24px","margin-bottom":"13px","margin-top":"13px"} }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { style: {"color":"#f50"} }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-top":"-4px","margin-left":"6px"},
  src: _imports_0
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_13 = { class: "right-layout bf" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "标签详情", -1))

import LabelEditModal from './LabelEditModal.vue'
import { ref, computed } from 'vue'
import { labelList, deleteLabel, updateLabel } from '@/api/yuntuSales/labelManage'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'


const __default__ = { name: 'DcCosLbuLabelManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const tableRef = ref()
const searchValue = ref<string>('')
const inputValue = ref<string>('')
const expandedKeys = ref<any[]>([])
const dataForm = ref<any>({
  parentName: '--',
  name: '--',
  labelType: 0,
  weight: '--',
  comment: '--',
  updateBy: '--',
  updateTime: '--'
})

const rowClick = (record: any) => {
  record.parentName = getParentName(record.parentId, allLabelList.value)?.name ?? '--'
  dataForm.value = record
}

const onSearch = () => {
  searchValue.value = inputValue.value

  getExpandedKey(allLabelList.value)
}

const onExpand = (expanded, record) => {
  if (expanded) {
    expandedKeys.value.push(record.id)
  } else {
    if (expandedKeys.value.length) {
      expandedKeys.value = expandedKeys.value.filter((v) => {
        return v !== record.id
      })
    }
  }
}

const getExpandedKey = (tree: any) => {
  if (tree) {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some((item) => item.name && item.name.indexOf(searchValue.value) > -1)) {
          expandedKeys.value.push(node.id)
        }

        getExpandedKey(node.children)
      }
    }
  }
}

const onStatusClick = (e: any, record?: any) => {
  const p = Object.assign({}, record)
  p.status = record?.status === 0 ? 1 : 0
  p.labelId = record.id
  p.labelName = record.name
  p.sort = record.weight
  updateLabel(p).then(() => {
    message.success('修改状态成功')
    tableRef.value?.fetch()
  })
}

const onDelete = (record?: any) => {
  Modal.delete({
    name: record.name,
    onOk() {
      deleteLabel({
        labelId: record.id
      }).then((res) => {
        message.success('删除成功')
        tableRef.value?.delFetch()
      })
    }
  })
}

const getParentName: any = (pid: number, list: any) => {
  if (list) {
    for (const child of list) {
      if (child.id === pid) {
        return child
      }
      const foundParent = getParentName(pid, child.children)
      if (foundParent) {
        return foundParent
      }
    }
  }
  return null
}

const onAdd = (record?: any) => {
  labelModalRef.value?.init(null, record)
}

const labelModalRef = ref()
const triggerAddOrEdit = (record?: any) => {
  if (record) {
    record.parentName = getParentName(record.parentId, allLabelList.value)?.name ?? '--'
  }

  labelModalRef.value?.init(record)
}
const allLabelList = ref()

// onMounted(() => {
//   fetch(null, () => {})
// })

const fetch = (q: any, callBack: (res: any) => void) => {
  labelList({ appId: 'cos_lbu' }).then((res) => {
    allLabelList.value = res.data
    callBack(res)
  })
}

const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

const labelTypeEnum = [
  {
    value: 0,
    label: '普通标签'
  },
  {
    value: 1,
    label: '特殊标签'
  }
]

const search = () => {
  tableRef.value.search()
}

const columns = computed(() => [
  {
    title: '标签名称',
    dataIndex: 'name'
  },
  {
    title: '类型',
    dataIndex: 'labelType'
  },
  {
    title: '状态',
    scopedSlots: { customRender: 'showDecimalsOrnot' },
    dataIndex: 'status'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 150
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, { class: "cos-full-layout" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_input, {
                value: inputValue.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
                placeholder: "输入名称查询标签"
              }, null, 8, ["value"]),
              _createVNode(_component_a_button, {
                style: {"margin-left":"13px"},
                type: "primary",
                onClick: onSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查询")
                ]),
                _: 1
              }),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                style: {"margin-left":"13px"},
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (triggerAddOrEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增一级标签")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_label_add_top_btn']
              ])
            ]),
            _createVNode(_component_cos_table, {
              bordered: "",
              serial: false,
              dynamicColumnSetting: false,
              needPage: false,
              columns: columns.value,
              expandedRowKeys: expandedKeys.value,
              onExpand: onExpand,
              onFetch: fetch,
              ref_key: "tableRef",
              ref: tableRef,
              tableId: "lbuLabelManage",
              id: "lbuLabelManage",
              rowKey: "id"
            }, {
              bodyCell: _withCtx(({ column, text, record }) => [
                (column.dataIndex === 'status')
                  ? (_openBlock(), _createBlock(_component_a_switch, {
                      checked: record.status,
                      "checked-children": _unref(t)('system.j8i04n'),
                      "un-checked-children": _unref(t)('system.426zce'),
                      checkedValue: 0,
                      unCheckedValue: 1,
                      key: record.name,
                      onClick: ($event: any) => (onStatusClick($event, record))
                    }, null, 8, ["checked", "checked-children", "un-checked-children", "onClick"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'name')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: ($event: any) => (rowClick(record))
                    }, [
                      (record.name && record.name.indexOf(searchValue.value) > -1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                            _createTextVNode(_toDisplayString(record.name.substr(0, record.name.indexOf(searchValue.value))) + " ", 1),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(searchValue.value), 1),
                            _createTextVNode(" " + _toDisplayString(record.name.substr(record.name.indexOf(searchValue.value) + searchValue.value.length)), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(record.name), 1))
                    ], 8, _hoisted_5))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'labelType')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(labelTypeEnum.find((v) => v.value == text)?.label), 1))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createBlock(_component_more_button, { key: 3 }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          onClick: ($event: any) => (onAdd(record))
                        }, {
                          icon: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'lbu_label_add_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          onClick: ($event: any) => (triggerAddOrEdit(record))
                        }, {
                          icon: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'lbu_label_edit_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          onClick: ($event: any) => (onDelete(record))
                        }, {
                          icon: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'lbu_label_delete_btn']
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "expandedRowKeys"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_a_form, {
              model: dataForm.value,
              ref: "formRef",
              "wrapper-col": { span: 30 }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_dc_form_item, {
                  name: "parentName",
                  label: "上级标签",
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: dataForm.value.parentName,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.value.parentName) = $event)),
                      disabled: true,
                      style: {"width":"100%"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  name: "labelName",
                  label: "标签名称",
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.value.name,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.value.name) = $event)),
                      disabled: true,
                      style: {"width":"100%"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "类型",
                  name: "labelType",
                  disabled: true,
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: dataForm.value.labelType,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.value.labelType) = $event)),
                      options: labelTypeEnum,
                      placeholder: "请选择",
                      allowClear: "",
                      style: {"width":"100%"},
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "sort",
                  label: "顺序",
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: dataForm.value.weight,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.value.weight) = $event)),
                      style: {"width":"100%"},
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  name: "comment",
                  label: "备注",
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: dataForm.value.comment,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.value.comment) = $event)),
                      style: {"width":"100%"},
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  name: "updateBy",
                  label: "操作人",
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: dataForm.value.updateBy,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.value.updateBy) = $event)),
                      style: {"width":"100%"},
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  name: "updateTime",
                  label: "操作时间",
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: dataForm.value.updateTime,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dataForm.value.updateTime) = $event)),
                      style: {"width":"100%"},
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(LabelEditModal, {
      ref_key: "labelModalRef",
      ref: labelModalRef,
      onFetch: _cache[9] || (_cache[9] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512)
  ], 64))
}
}

})